import React, { useState, useEffect } from 'react';

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function pad(n) {
  var s = Math.abs(n).toFixed(0);

  while (s.length < 2) {
    s = "0".concat(s);
  }

  return s;
}

var second = 1000;
var minute = second * 60;
function renderDuration(duration) {
  var minutes = ~~(duration / minute);
  var seconds = ~~(duration % minute / second);
  var sg = duration < 0 ? '-' : '';
  return "".concat(sg).concat(pad(minutes), ":").concat(pad(seconds));
}

var defaultColorConfig = {
  normal: 'black',
  almostOut: 'orange',
  negative: 'red'
};
var FIVE_MINUTES = 300000;
function color(remaining, config) {
  var realConfig = Object.assign(Object.assign({}, defaultColorConfig), config);
  if (remaining > FIVE_MINUTES) return realConfig.normal;
  if (remaining > 0) return realConfig.almostOut;
  return realConfig.negative;
}

function setProperInterval(callback, ms) {
  var playing = true;
  var start = document.timeline.currentTime || Date.now();

  function frame(time) {
    if (!playing) return;
    callback(time);
    scheduleFrame(time);
  }

  function scheduleFrame(time) {
    var elapsed = time - start;
    var roundedElapsed = Math.round(elapsed / ms) * ms;
    var targetNext = start + roundedElapsed + ms;
    var delay = targetNext - performance.now();
    setTimeout(function () {
      return requestAnimationFrame(frame);
    }, delay);
  }

  scheduleFrame(start);
  return {
    stop: function stop() {
      return playing = false;
    }
  };
}
function clearProperInterval(interval) {
  interval.stop();
}

function toTime(ed) {
  if (!ed) {
    throw 'Needed a number, date or String';
  }

  return new Date(ed).getTime();
}

function noop() {}

var Countdown = function Countdown(_ref) {
  var end = _ref.end,
      _ref$onTick = _ref.onTick,
      onTick = _ref$onTick === void 0 ? noop : _ref$onTick,
      _ref$colors = _ref.colors,
      colors = _ref$colors === void 0 ? {} : _ref$colors,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
  var realEnd = toTime(end);

  function duration() {
    return realEnd - Date.now();
  }

  var _useState = useState(duration()),
      _useState2 = _slicedToArray(_useState, 2),
      remaining = _useState2[0],
      setRemaining = _useState2[1];

  useEffect(function () {
    setRemaining(duration());
    var interval = setProperInterval(function () {
      var newVal = duration();
      setRemaining(newVal);
      onTick(newVal);
    }, 1000);
    return function () {
      return clearProperInterval(interval);
    };
  }, [end]);
  return React.createElement(React.Fragment, null, React.createElement("p", {
    style: Object.assign({
      color: color(remaining, colors)
    }, style)
  }, renderDuration(remaining)));
};

export default Countdown;
export { minute, renderDuration, second };
